// extracted by mini-css-extract-plugin
export default {"cupContainer":"styles__cupContainer___CMDAL","iconPadding":"styles__iconPadding___rS2Rl"};